import { ResponseAccountData } from '@api/models/response-account-data';
import { Customer } from '@core/models/customer.model';
import { Injectable } from '@angular/core';
import { map, filter, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '@environment/environment';
import { ResponseAccount } from '@api/models/response-account';
import { SalesforceResponse } from '@api/models';
import { KycUpdate } from '@api/models/kycUpdate.model';
import { NotificationService } from '@api/services/notification.service';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  private currentCustomerSource = new BehaviorSubject<ResponseAccountData>(null);
  constructor(private httpClient: HttpClient, private notificationService: NotificationService) {}

  get currentCustomer() {
    return this.currentCustomerSource.getValue();
  }

  get currentCustomer$() {
    return this.currentCustomerSource.pipe(filter((it) => !!it));
  }

  setCurrentCustomer(customer: ResponseAccountData) {
    this.currentCustomerSource.next(customer);
  }

  getAccount() {
    const url = `${environment.apiBasePath}${environment.endpoints.account}`;
    return this.httpClient
      .get<SalesforceResponse<ResponseAccount>>(url)
      .pipe(
        map((response) => response.data[0].EE_O_ConsultaPersonaAmpliadaBE?.Respuesta),
        tap(({ OtrosDatosPersona, DatosPersonales }) => this.notificationService.setNotifications(OtrosDatosPersona, DatosPersonales))
      );
  }

  updateAccount(body: KycUpdate) {
    const url = `${environment.apiBasePath}${environment.endpoints.account}`;
    return this.httpClient.put(url, body);
}
}

export function createCustomerMap() {
  return (source: Observable<ResponseAccountData>) =>
    source.pipe(
      map((data) => {
        return new Customer(
          data.DatosPersonales.nombreCliente,
          data.DatosPersonales.apellido1Cliente,
          data.DatosPersonales.apellido2Cliente,
          data.DatosPersonales.codigoIdExterno,
          data.DatosPersonales.idExterno,
          data.DatosDomicilio.codigoDomicilioTipoVia,
          data.DatosDomicilio.nombreVia,
          data.DatosDomicilio.domicilioNumero,
          data.DatosDomicilio.domicilioPortal,
          data.DatosDomicilio.domicilioPlanta,
          data.DatosDomicilio.domicilioPuerta,
          data.DatosPersonales.codigoPostal,
          data.DatosDomicilio.nombreLocalidad,
          data.DatosDomicilio.nombreProvinciaDomicilio,
          data.DatosPersonales.telefonoMovil,
          data.DatosPersonales.mail,
          data.DatosSocioEconomicos.codigoSituacionLaboral,
          data.OtrosDatosPersona.indPerfilDatExternos,
          data.OtrosDatosPersona.indPerfilPropPublic,
          data.OtrosDatosPersona.indPubliPe,
          data.OtrosDatosPersona.indNoCesionEmpNoGrupo,
          data.OtrosDatosPersona.indNoCesiEmpGrupo
        );
      })
    );
}
